
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Contact',
  data() {
    return {
      links: [
        {
          icon: 'far fa-envelope',
          title: 'Mail',
          url: 'mailto:nomeacuerdo@gmail.com?subject=Contact from nomeacuerdo.co&body=Hi! I come in peace.',
          color: '#F14336',
        }, {
          icon: 'fab fa-linkedin',
          title: 'Linkedin',
          url: 'https://www.linkedin.com/in/nomeacuerdo/',
          color: '#0077b5',
        }, {
          icon: 'fab fa-github',
          title: 'Github',
          url: 'https://github.com/nomeacuerdo',
          color: '#0366d6',
        }, {
          icon: 'fab fa-mastodon',
          title: 'Mastodon',
          url: 'https://col.social/@nomeacuerdo',
          color: '#595aff',
        }, {
          icon: 'fab fa-instagram',
          title: 'Instagram',
          url: 'https://instagram.com/nomeacuerdo',
          color: '#C13584',
        },
      ],
    };
  },
});
